export default "__VITE_ASSET__DNzDcK9I__"